import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import A from 'aphrodite';
import R from 'ramda';
import { ListItem, Divider, IconMenu, MenuItem, IconButton, FontIcon, LinearProgress } from 'material-ui';
import FileDownloadIcon from 'material-ui/svg-icons/file/file-download';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';

import RaisedButton from '../../../../tc-ui/raised-button-with-loader';

import {
  downloadFromUrl as downloadFromUrlAction,
} from '../../../../../stores/actions';
import {
  addFileToContractInDB as addFileToContractInDBAction,
  deleteFileFromContractInDB as deleteFileFromContractInDBAction,
  modifyFileFromContractInDB as modifyFileFromContractInDBAction,
} from '../../../../../stores/contracting/contract-activities-products/contract-activities-products-actions';
import { deleteFileFromS3, bulkDownloadS3File } from '../../../../../stores/actions';
import Dropzone from '../../../../extra/dropzone/dropzone';
import s3uploadFns from '../../../../../utils/s3Upload';
import ReactSelect from 'react-select';
import TextField from 'material-ui/TextField';

const styles = A.StyleSheet.create({
  uploadArea: { border: '4px dashed rgb(239, 239, 239)', padding: '12px 8px', clear: 'both', minHeight: '150px' },
});
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const propTypes = {
  contractId: PropTypes.string,
  files: PropTypes.array,
  downloadFromUrl: PropTypes.func,
  addFileToContractInDB: PropTypes.func,
  deleteFileFromContractInDB: PropTypes.func,
  modifyFileFromContractInDB: PropTypes.func,
  isLatest: PropTypes.bool,
  to: PropTypes.object,
  from: PropTypes.object,
};

const CATEGORIES = ['All', 'Rates', 'Allotment', 'Special Event Dates and Close Outs', 'Dynamic', 'General'];

class NotesAndFilesExternalFiles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filesUploading: [],
      filesUploaded: [],
      removing: [],
      filingContractId: '',
      allCheckedIds: [],
      selectedCategory: 'All',
      editingFile: null,
      editValues: {},
      saving: false,
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  dropFiles = droppedFiles => {
    const { addFileToContractInDB, contractId } = this.props;
    const _this = this;
    this.setState({
      filesUploading: droppedFiles.map(file => ({ name: file.name, percent: 0 })),
      filesUploaded: [],
    }, () => {
      droppedFiles.forEach((file, fileIndex) => {
        return s3uploadFns.s3upload({
          file_to_upload: file,
          file_name: file.name,
          ACL: 'private',
          onFinishS3Put(path) {
            const { filesUploaded, filesUploading } = _this.state;
            const uploadedFileInfo = {
              path,
              name: file.name,
              type: file.type,
              size: file.size,
            };
            const allUploaded = [...filesUploaded, uploadedFileInfo];
            _this.setState({ filesUploaded: allUploaded }, () => {
              if (allUploaded.length === filesUploading.length) {
                _this.setState({
                  filesUploading: [],
                  filesUploaded: [],
                }, () => {
                  addFileToContractInDB(contractId, allUploaded);
                });
              }
            });
          },
          onProgress(percent) {
            _this.setState({
              filesUploading: _this.state.filesUploading.map((fileInState, i) => {
                if (i === fileIndex) return R.merge(fileInState, { percent });
                return fileInState;
              }),
            });
          },
          onError(status) {
            console.log(status);
          },
        });
      });
    });
  }
  handleEdit = (file) => {
    this.setState({
      editingFile: file._id,
      editValues: {
        [file._id]: {
          name: file.name,
          category: file.category || ''
        }
      }
    });
  }
  handleSave = () => {
    const { contractId, modifyFileFromContractInDB } = this.props;
    const { editingFile, editValues } = this.state;
    const editedValues = editValues[editingFile];
    const updates = {
      'files.$.name': editedValues.name,
      'files.$.category': editedValues.category
    };

    this.setState({ saving: true });
    modifyFileFromContractInDB(contractId, editingFile, updates)
      .then(() => this.setState({ 
        saving: false, 
        editingFile: null,
        editValues: {}
      }));
  }
  render() {
    const { filesUploading, removing } = this.state;
    const {
      contractId,
      deleteFileFromContractInDB,
      downloadFromUrl,
      files,
      isLatest,
      to,
      from,
    } = this.props;
    const hasExternalFiles = Boolean(files && files.length);
    return (
      <div>
        {
          hasExternalFiles && (
            <div className="flex-tc-sb" style={{ marginBottom: '16px' }}>
              <h4>External Files</h4>
              <div className="flex-tc-sb">
                <select
                  value={this.state.selectedCategory}
                  onChange={(e) => this.setState({ selectedCategory: e.target.value })}
                  style={{ marginRight: '16px' }}
                >
                  {CATEGORIES.map(category => (
                    <option key={category} value={category}>{category}</option>
                  ))}
                </select>
                <RaisedButton
                  label="Download All"
                  secondary
                  onTouchTap={() => bulkDownloadS3File(this.props.files, `${to.name} Rates`)}
                  icon={<FileDownloadIcon />}
                />
              </div>
            </div>
          )
        }
        {
          !hasExternalFiles && (
            <div style={{ padding: '16px 0', fontSize: '18px', color: 'rgba(0, 0, 0, 0.44)' }}>
              You haven't received any rate files. Or you can upload files as well.
            </div>)
        }
        {
          Boolean(files && files.length) && (
            <div style={{ borderBottom: '1px solid #e0e0e0', marginBottom: '16px', paddingBottom: '4px' }} >
              {
                files
                  .filter(file => this.state.selectedCategory === 'All' || file.category === this.state.selectedCategory)
                  .map((file, fileIndex) => {
                    const addedByBuyer = ['directUpload', 'emailScrape'].indexOf(file.source) > -1
                    || file.source.indexOf('emailId') > -1;
                    // const addedBySupplier = file.source === 'supplierSent';
                    // const enableEditOptions = (
                    //   (companyType === 'Contractor' && addedByBuyer)
                    //   || (companyType === 'Supplier' && addedBySupplier)
                    // ) && isLatest;
                    return (
                      <div
                        key={`${file._id}${fileIndex}`}
                        style={(removing.indexOf(file._id) > -1) ? { filter: 'blur(2px) ' } : {}}
                      >
                        <ListItem
                          onTouchTap={() => downloadFromUrl(file)}
                          disabled={this.state.editingFile === file._id}
                          secondaryText={
                            `${addedByBuyer
                              ? `Added By ${from.name}`
                              : `Sent By ${to.name}`} on ${moment(file.createdAt).format('l')}`}
                          primaryText={
                            this.state.editingFile === file._id ? (
                              <div>
                                <div className="flex-tc-sb" style={{ display: 'flex', flexWrap: 'wrap', gap: '5%', marginBottom: '8px' }}>
                                  <TextField
                                    style={{ width: '75%' }}
                                    autoFocus
                                    variant="outlined"
                                    value={this.state.editValues[file._id].name}
                                    onChange={e => this.setState({
                                      editValues: {
                                        ...this.state.editValues,
                                        [file._id]: {
                                          ...this.state.editValues[file._id],
                                          name: e.target.value
                                        }
                                      }
                                    })}
                                    floatingLabelText="File Name"
                                  />
                                  <div style={{ width: '20%' }}>
                                    <select
                                      value={this.state.editValues[file._id].category}
                                      onChange={(e) => this.setState({
                                        editValues: {
                                          ...this.state.editValues,
                                          [file._id]: {
                                            ...this.state.editValues[file._id],
                                            category: e.target.value
                                          }
                                        }
                                      })}
                                      style={{ width: '100%', height: 'auto', padding: '10px', margin: '0', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
                                    >
                                      <option value="">Select Category</option>
                                      {CATEGORIES.filter(cat => cat !== 'All').map(category => (
                                        <option key={category} value={category}>{category}</option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="flex-tc-sb" style={{ marginTop: '8px' }}>
                                  <RaisedButton
                                    primary
                                    label="Cancel"
                                    loader={this.state.saving}
                                    onTouchTap={() => this.setState({ 
                                      editingFile: null,
                                      editValues: {}
                                    })}
                                  />
                                  <RaisedButton
                                    secondary
                                    label="Save"
                                    loader={this.state.saving}
                                    disabled={
                                      file.name === this.state.editValues[file._id].name && 
                                      file.category === this.state.editValues[file._id].category
                                    }
                                    onTouchTap={this.handleSave}
                                  />
                                </div>
                              </div>
                            ) : (
                              <span>
                                {file.name}
                                {file.category && ` (${file.category})`}
                              </span>
                            )
                          }
                          rightIconButton={
                            <IconMenu
                              desktop
                              iconButtonElement={(<IconButton
                                touch
                                tooltip="More Actions"
                                tooltipPosition="bottom-left"
                              >
                                <MoreVertIcon color="grey" />
                              </IconButton>)}
                            >
                              <MenuItem leftIcon={<FileDownloadIcon />} primaryText="Download" onTouchTap={() => downloadFromUrl(file)} />
                              <MenuItem
                                leftIcon={<DeleteIcon />}
                                primaryText="Remove"
                                onTouchTap={() => {
                                  this.setState({ removing: [...removing, file._id] }, () => {
                                    deleteFileFromContractInDB(contractId, file._id).then(() => {
                                      if (file.source === 'directUpload') deleteFileFromS3(file.path);
                                    });
                                  });
                                }}
                              />
                              <MenuItem
                                leftIcon={<EditIcon />}
                                primaryText="Edit"
                                onTouchTap={() => this.handleEdit(file)}
                              />
                            </IconMenu>}
                        />
                        {fileIndex !== files.length - 1 && <Divider />}
                      </div>);
                  })
              }
            </div>
          )
        }
        <Dropzone
          className={A.css(styles.uploadArea)}
          style={{ display: isNilOrEmpty(filesUploading) ? 'flex' : 'none', alignItems: 'center', fontSize: '16px', color: 'rgba(0, 0, 0, 0.44)' }}
          onDrop={this.dropFiles}
        >
          <FontIcon className="tc-icon-add" color="#bfbfbf" style={{ fontSize: '100px', marginRight: '16px' }} />
          Attach files by dragging & dropping or&nbsp;<span style={{ color: '#00b3cf', cursor: 'pointer' }}>selecting them</span>
        </Dropzone>
        {
          !isNilOrEmpty(filesUploading) && (
            <div className={A.css(styles.uploadArea)}>
              {
                filesUploading.map((file, index) => (
                  <div
                    key={`${index}${file.name}`}
                    style={{ color: 'rgba(0, 0, 0, 0.54)', lineHeight: '54px' }}
                  >
                    <div>{file.name}</div>
                    <LinearProgress mode="determinate" value={file.percent} style={{ width: '50%', height: '8px', borderRadius: '8px' }} />
                  </div>
                ))
              }
            </div>
          )
        }
      </div>
    );
  }
}

NotesAndFilesExternalFiles.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  downloadFromUrl: (...args) => dispatch(downloadFromUrlAction(...args)),
  addFileToContractInDB: (contractId, files) => dispatch(addFileToContractInDBAction(contractId, files, 'contract')),
  deleteFileFromContractInDB: (...args) => dispatch(deleteFileFromContractInDBAction(...args)),
  modifyFileFromContractInDB: (...args) => dispatch(modifyFileFromContractInDBAction(...args)),
});
export default connect(({ contracting }) => {
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const rightSideContent = contracting.contractActivitiesProducts.get('rightSideContent').toJS();
  return {
    contractId: leftNav.contractId,
    viewingAs: leftNav.viewingAs,
    partners: leftNav.partners,
    contacts: leftNav.contacts,
    from: leftNav.from,
    to: leftNav.to,
    isLatest: leftNav.isLatest,
    rateConversionStatus: leftNav.rateConversionStatus,
    rateConversionSetting: leftNav.rateConversionSetting,
    files: rightSideContent.files,
    deadlineDate: rightSideContent.deadlineDate,
    buyerInfo: rightSideContent.buyerInfo,
    respondedContractList: leftNav.respondedContractList,
    respondedContracts: leftNav.respondedContracts,
  };
}, mapDispatchToProps)(NotesAndFilesExternalFiles);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/contract-request-buyer-view/external-files.jsx